import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import eventStatusTypes from "./event-status-types";

const RestrictedEventNotDeleted = ({ event, children }) => {
  return event && event.eventStatus === eventStatusTypes.DELETED ? (
    <h1>
      <FormattedMessage id="common.security.noAccess" />
    </h1>
  ) : (
    children
  );
};

RestrictedEventNotDeleted.propTypes = {
  /**
   * Evento al que se intenta tener acceso
   */
  event: PropTypes.object,
};

export default RestrictedEventNotDeleted;
